import { Injectable, signal } from '@angular/core';
import { DialogService } from './dialog.service';

/**
 * "Mi sitio" ya no tiene botones de guardar por campo (todo se ve en vivo en
 * la vista previa, ver mi-sitio.component.ts) -- este servicio es lo que
 * evita que un cambio se pierda silenciosamente: DashboardComponent lo
 * consulta en selectTab() antes de dejar la pestaña "Mi sitio", y si hay
 * cambios sin guardar pide confirmación antes de continuar.
 */
@Injectable({ providedIn: 'root' })
export class MiSitioUnsavedChangesService {
  readonly hasUnsavedChanges = signal(false);

  constructor(private dialogs: DialogService) {}

  confirmLeave(): Promise<boolean> {
    return this.dialogs.confirm({
      title: 'Tienes cambios sin guardar',
      message: 'Si sales de "Mi sitio" ahora, los cambios que no guardaste se van a perder.',
      tone: 'warning',
      confirmText: 'Salir sin guardar',
      cancelText: 'Seguir editando',
    });
  }
}
